// extracted by mini-css-extract-plugin
export default {"statistics":"Statistics_statistics__MHVAH","title":"Statistics_title__eCJPs","list":"Statistics_list__QSSKj","item":"Statistics_item__5jALf","label":"Statistics_label__8YVf8"};